<ng-container *ngIf="draws?.length && [BrokerStatus.OPEN, BrokerStatus.FUNDED, BrokerStatus.RENEWED, BrokerStatus.CLOSED].includes(brokerStatus)">
  <section class="table">
    <div class="table__header">
      <p class="table__cell table__cell--label">Draw amount</p>
      <p class="table__cell table__cell--label">Draw date</p>
      <p class="table__cell table__cell--label">Disbursed amount</p>
      <p class="table__cell table__cell--label">Status</p>
    </div>
    <div class="table__row" *ngFor="let draw of draws; trackBy: trackByIndex">
      <p class="table__cell">
        <ng-container *ngIf="draw?.totalAmount || draw?.totalAmount === 0; else notAvailable">
          {{ draw.totalAmount | currency }}
        </ng-container>
      </p>
      <p class="table__cell">
        <ng-container *ngIf="draw?.transactionDate; else notAvailable">
          {{ draw.transactionDate | date }}
        </ng-container>
      </p>
      <p class="table__cell">
        <ng-container *ngIf="draw?.disbursedAmount || draw?.disbursedAmount === 0; else notAvailable">
          {{ draw.disbursedAmount | currency }}
        </ng-container>
      </p>
      <p class="table__cell">
        <ng-container *ngIf="draw?.status || draw?.status === 0; else notAvailable">
          {{ draw.status | enumValueLabel : TransactionStatus : transactionStatusLabel }}
        </ng-container>
      </p>
    </div>
  </section>
  <ng-template #notAvailable>N/A</ng-template>
</ng-container>
